// removed by extract-text-webpack-plugin
module.exports = {"root":"Layout__root--hXdm-","sidebar":"Layout__sidebar--KClvl","main":"Layout__main--2G1WR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Library/Layout/Layout.css
// module id = ./src/components/Library/Layout/Layout.css
// module chunks = 1